import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import PcrApplicationsListPage from './pcr-applications-list'
import PcrPaymentsPage from './pcr-payments'
import { PcrStaffApplicationStatisticsPage } from './pcr-staff-application-statistics'

const pcrPersonalSpaceRoutes: Route[] = [
  {
    path: Paths.PCR_APPLICATIONS_PAGE,
    element: <PcrApplicationsListPage />,
    roles: [RoleEnum.PCR]
  },
  {
    path: Paths.PCR_PAYMENTS_PAGE,
    element: <PcrPaymentsPage />,
    roles: [RoleEnum.PCR]
  },
  {
    path: Paths.PCR_PERSONAL_SPACE_BASIC_STATISTICS,
    element: <PcrStaffApplicationStatisticsPage />
  }
]

export default pcrPersonalSpaceRoutes
